<mat-dialog-content class="adap-dialog-content">
  <ng-container *ngIf="formState$ | async as formState">
    <app-dialog-header
      [title]="
        isNew
          ? 'add new discipline'
          : formState.controls.code.value! +
            ' - ' +
            formState.controls.name.value!
      "
    ></app-dialog-header>
    <form [ngrxFormState]="formState" class="adap-form-container">
      <div class="request-section">
        <div class="custom-discipline-input-container">
          <app-input-container
            label="discipline (full name)"
            labelFor="disciplineName"
            [isRequired]="true"
            [app-input-validation-container]="formState.controls.name"
          >
            <input
              id="disciplineName"
              name="disciplineName"
              type="text"
              placeholder="enter discipline name"
              maxlength="100"
              class="adap-form-input"
              [ngrxFormControlState]="formState.controls.name!"
            />
          </app-input-container>
          <app-input-container
            label="abbreviation for discipline"
            labelFor="disciplineAbbreviation"
            [isRequired]="true"
            [app-input-validation-container]="formState.controls.code"
          >
            <input
              id="disciplineAbbreviation"
              name="disciplineAbbreviation"
              type="text"
              placeholder="enter discipline abbreviation"
              maxlength="3"
              class="adap-form-input"
              [ngrxFormControlState]="formState.controls.code!"
              (input)="onChangeCode($event)"
            />
          </app-input-container>
        </div>
      </div>
      <app-separator></app-separator>
      <div class="request-section">
        <h3>request</h3>
        <div class="section-input">
          <app-multi-users-search
            label="chapter manager"
            [ngrxFormControlState]="formState.controls.chapterManagers!"
          ></app-multi-users-search>
        </div>
      </div>
    </form>
    <div class="dialog-actions">
      <div>
        <button class="adap-btn-outline" type="button" (click)="closeWindow()">
          cancel
        </button>
        <button class="adap-btn-filled" type="button" (click)="save(isNew)">
          save
        </button>
      </div>
    </div>
  </ng-container>
</mat-dialog-content>
